import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

interface Placeholder {
  title: string;
  description?: string;
  image: string;
}

@Component({
  selector: 'app-empty-content',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section>
      <img [src]="placeholder.image" width="80" height="80" />
      <h2>{{ placeholder.title }}</h2>
      @if (placeholder.description) {
      <p>{{ placeholder.description }}</p>
      }
    </section>
  `,
  styles: [
    `
      section {
        text-align: center;
      }
      h2 {
        font-size: 1rem !important;
        margin-bottom: 0.125 !important;
        margin-top: 0.4rem !important;
        max-width: 310px;
        font-weight: 400;
        text-wrap: pretty;
      }
      p {
        font-size: 1rem;
      }
    `,
  ],
})
export class EmptyContentComponent implements OnInit {
  @Input() content: 'errors' | 'content';

  private emptyContentPlaceholders: Array<Placeholder> = [
    {
      title: 'Nothing to see yet',
      image:
        '../../assets/images/editorimages/placeholders/editor-page-nothing-to-check-yet.avif',
    },
    {
      title: 'Words have power. Ready to make some magic?',
      image:
        '../../assets/images/editorimages/placeholders/editor-page-words-have-magic-book.avif',
    },
    {
      title: 'Nothing to see yet',
      image:
        '../../assets/images/editorimages/placeholders/editor-page-nothing-to-check-yet-book-magnifying-glass.avif',
    },
    {
      title: 'Hit the keys, and let your thoughts flow!',
      image:
        '../../assets/images/editorimages/placeholders/editor-page-hit-the-keys.avif',
    },
    {
      title: 'Unleash your creativity - start with one sentence.',
      image:
        '../../assets/images/editorimages/placeholders/editor-page-unleash-your-creativity.avif',
    },
  ];

  private emptyErrorsPlaceholders: Array<Placeholder> = [
    {
      title: 'All clear! Your text is looking sharp and polished.',
      image:
        '../../assets/images/editorimages/placeholders/editor-page-no-errors-all-clear.avif',
    },
    {
      title: 'Clean slate! Your writing is good to go.',
      image:
        '../../assets/images/editorimages/placeholders/editor-page-no-errors-slate.avif',
    },
    {
      title: 'No error found!',
      image:
        '../../assets/images/editorimages/placeholders/editor-page-no-errors-telescope.avif',
    },
    {
      title: 'Locked in perfection - your writing is secure and stellar!',
      image:
        '../../assets/images/editorimages/placeholders/editor-page-no-errors-lock.avif',
    },
  ];

  placeholder: Placeholder;

  ngOnInit(): void {
    const array: Array<Placeholder> =
      this.content === 'errors'
        ? this.emptyErrorsPlaceholders
        : this.emptyContentPlaceholders;

    this.randomPlaceholder(array);
  }

  private randomPlaceholder(array: Array<Placeholder>) {
    const rand = Math.floor(Math.random() * array.length);
    this.placeholder = array[rand];
  }
}
